import React, { useState, useEffect } from "react"

import { Form, Row } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import { useUTMTracking } from "../../hooks/useUTMTracking"
import moment from "moment";
import axios from "axios";
import * as qs from "query-string";
import _ from "lodash";

const to_email_id ="emily.south@tlclondon.com,samantha@tlclondon.com";

function MySimpleForm(props) {
    const [validated, setValidated] = useState(false);
    const [showerror, setShowerror] = useState(false);
    const [showthankyou, setThankyou] = useState(false);
    const [formvalues, setFormvalues] = useState("");
    const [token, setToken] = useState("");
    const myRef = React.createRef();
    const recaptchaRef = React.createRef();
    const [countryCode, setCountryCode] = useState('');
    const [showCapcha, setShowCaptch] = useState(true);
    const utmData = useUTMTracking();

    useEffect(() => {
        axios.get('https://extreme-ip-lookup.com/json/').then(response => {
        //console.log("countryCode", response.data.countryCode);
            setCountryCode(response.data.countryCode)
        }).catch(err =>
            console.log(err)
        );
    },[]);

    let fields = ([
        {
            element: "config",
            formname: props.formname ? props.formname: "Contact",
            form_type: "contact",
            error_text: "Highlighted fields are required | invalid",
            success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
            email_temp_user: "contact_user",
            email_temp_admin: "contact_admin",
            email_subject_user: props.user_subject ? props.user_subject : "Contact",
            email_subject_admin: props.admin_subject ? props.admin_subject :  "Contact",
            email_server_func: "contact",
            event_tracking: "contact",
            page_url: "/contact"
        },
        {
            grpmd: "12",
            label: "Full Name",
            placeholder: "Full name",
            name: "full_name",
            type: "text",
            element: "input",
            required: true,
            patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
            labelClass: "content_b-18"
        },
        // {
        //     grpmd: "12",
        //     label: "First Name",
        //     placeholder: "First name",
        //     name: "first_name",
        //     type: "text",
        //     element: "input",
        //     required: true,
        //     patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        //     labelClass: "content_b-18"
        // },
        // {
        //     grpmd: "12",
        //     label: "Last Name",
        //     placeholder: "Last name",
        //     name: "last_name",
        //     type: "text",
        //     element: "input",
        //     required: true,
        //     patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        //     labelClass: "content_b-18"
        // },
        {
            grpmd: "12",
            label: "Email Address:",
            placeholder: "Email Address",
            name: "email",
            type: "email",
            element: "input",
            required: true,
            patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
            labelClass: "content_b-18"
        },
        {
            grpmd: "12",
            label: "Telephone",
            placeholder: "Phone number",
            name: "telephone",
            type: "text",
            element: "input",
            required: true,
            patternchk:"^(?=(?:.*\\d){9,})(\\+\\d{1,3}[\\s-]?)?[0-9()\\s-]+$",
            labelClass: "content_b-18"
        },
        {
            grpmd: "12",
            label: "What do you need help with?",
            placeholder: "What do you need help with?",
            name: "about",
            values: props.options ? props.options : [],
            type: "select",
            element: "select",
            required: true,
            patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
            labelClass: "content_b-18"
        },
        {
            grpmd: "12",
            label: "Message",
            placeholder: "Write your message here",
            name: "message",
            element: "textarea",
            class: "mb-0 pt-2",
            rows:"4",
            labelClass: "content_b-18"
        },
        {
            grpmd: "12",
            name: "SUBMIT",
            type:"submit",
            element: "button",
            value: "Submit Enquiry",
            class: "btn subscribe-btn btn btn-primary w-100 mb-4",
            labelClass: "content_b-18"
        },
        {
            text: 'By clicking Submit, you agree to our <a href="/terms-and-conditions/">Terms &amp; Conditions</a> and <a href="/privacy-policy/">Privacy Policy.</a>',
            element: "html",
            class: "form-txt content_r-m contact"
        },
        {
            element: "captcha",
            class: "py-2",
            captchaRef: recaptchaRef
        },
    ]);

    const handlechange = event => {
        // remove initial empty spaces
        event.target.value = event.target.value.trimStart()
    }

    useEffect(() => {
        if (token !== '') {
            const processFromData = async () => {
                let formData = new FormData();
                formData.append('data', JSON.stringify(formvalues));
                postFormData(formData).then(async apiRes => {
                    // lets send mail
                    // await recaptchaRef.current.reset();
                    await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
                        method: `POST`,
                        mode: "no-cors",
                        headers: {
                          'Access-Control-Allow-Origin': '*',
                          "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: qs.stringify(formvalues),
                    })
                });

                formvalues['g-recaptcha-response'] = token;

                // tracking event
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'formSubmit',
                    'formType': 'form-'+fields[0].event_tracking,
                    'formId': 'form-'+fields[0].event_tracking,
                    'formName': props.formname ? props.formname : fields[0].formname,
                    'formLabel': props.formname ? props.formname : fields[0].formname
                });

                setShowerror(false);
                setThankyou(true);
                setShowCaptch(false);
                setTimeout(() => {
                    setThankyou(false);
                    setShowCaptch(true)
                }, 3000);
                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })

            }
            processFromData();
        }
    }, [token]);

    const handleonVerify = token => {
        setToken(token);
    };

    const handleSubmit = event => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setShowerror(true);
            setValidated(true);
            setThankyou(false);
            myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else {
            const formsdata = (event.target);
            const json = {};
            Object.keys(formsdata).map(key => (
                json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
            ))
            json['email_temp_user'] = fields[0].email_temp_user;
            json['email_temp_admin'] = fields[0].email_temp_admin;
            json['formname'] = fields[0].formname;
            json['g-recaptcha-response'] = token;
            json['email_subject_user'] = fields[0].email_subject_user;
            json['email_subject_admin'] = fields[0].email_subject_admin;

            if(props.email) {
                var propsEmail = props.email             
                if(props.formname == "Contact Property Valuation"){
                    propsEmail ="valuations@tlclondon.com";
                }
                if(props.formname == "Contact Block Management"){
                    propsEmail +=",Jamie@tlclondon.com";
                }
                if(props.formname == "Contact Events"){
                    propsEmail +=",toby.brown@tlclondon.com";
                }
                if(props?.formname == "Person Contact" && props?.email == "elias@tlclondon.com"){
                    propsEmail +=",jamie@tlclondon.com";
                }
                json["to_email_id"] = propsEmail;
            }

            if(props.formname) {
                json["formname"] = props.formname;
                json["form_name"] = props.formname;
            }

            //json["name"] = json["first_name"] + " " + json["last_name"];
            json["name"] = json["full_name"]

            // Add UTM tracking data to extra
            json['extra'] = _.omit(json, ["formname", "name", "email", "telephone", "full_name", "about", "message", "form_name", "form_type", "to_email_id", "g-recaptcha-response", "email_temp_user", "email_temp_admin", "email_subject_user", "email_subject_admin"])

            // Ensure UTM data is in extra
            json['extra']['utm_source'] = utmData.utm_source;
            json['extra']['utm_medium'] = utmData.utm_medium;
            json['extra']['utm_campaign'] = utmData.utm_campaign;
            json['extra']['utm_term'] = utmData.utm_term;
            json['extra']['utm_content'] = utmData.utm_content;
            json['extra']['gclid'] = utmData.gclid;
            json['extra']['fbclid'] = utmData.fbclid;
            json['extra']['landing_page_url'] = utmData.landing_page_url;
            json['extra']['referrer'] = utmData.referrer;

            setFormvalues(json);
            recaptchaRef.current.execute();
            setValidated(false);
            // reset form
            const form = event.target
            form.reset();
        }
    };

    return (
        <div className="form-wrapper">
            <div ref={myRef} />

            {showerror && <div className="alert alert-danger mb-4 text-center">
                <p className="mb-0">{fields[0].error_text}</p>
            </div>}

            {showthankyou && <div className="alert alert-success mb-4 text-center">
                <p className="mb-0">{fields[0].success_text}</p>
            </div>}
            
            <Form name={fields[0].formname} id="contact-form" noValidate validated={validated} onSubmit={handleSubmit}>
                <input type="hidden" name="form_name" value={fields[0].formname} />
                <input type="hidden" name="form_type" value={fields[0].form_type} />
                <input type="hidden" name="to_email_id" value={to_email_id} />
                <input type="hidden" name="bot-field" />

                {/* UTM Tracking Fields */}
                <input type="hidden" name="utm_source" value={utmData.utm_source} />
                <input type="hidden" name="utm_medium" value={utmData.utm_medium} />
                <input type="hidden" name="utm_campaign" value={utmData.utm_campaign} />
                <input type="hidden" name="utm_term" value={utmData.utm_term} />
                <input type="hidden" name="utm_content" value={utmData.utm_content} />
                <input type="hidden" name="gclid" value={utmData.gclid} />
                <input type="hidden" name="fbclid" value={utmData.fbclid} />
                <input type="hidden" name="landing_page_url" value={utmData.landing_page_url} />
                <input type="hidden" name="referrer" value={utmData.referrer} />

                <Row >
                    {fields.map((field, index) => {
                        if ( "input" === field.element ) {
                            return (
                                <InputField
                                    key={index}
                                    name={field.name}
                                    grpmd={field.grpmd}
                                    ref={field.ref}
                                    type={(field.type === "date" || field.type === "time") ? "text" : field.type}
                                    fieldClass={field.class}
                                    label={field.label}
                                    labelClass={field.labelClass}
                                    placeholder={field.placeholder}
                                    required={field.required}
                                    pattern={field.patternchk}
                                    handlechange={handlechange}
                                    min={field.type == "date" ? moment().format("YYYY-MM-DD") : ""}
                                    onFocus={(e) => {
                                        if(field.type === "date" || field.type === "time") {
                                            e.target.type = field.type
                                        }
                                    }}
                                />
                            );
                        }
                        if ("select" === field.element && field.values.length > 0) {
                            return (
                                <SelectField
                                    key={index}
                                    name={field.name}
                                    grpmd={field.grpmd}
                                    label={field.label}
                                    ref={field.ref}
                                    required={field.required}
                                    fieldClass={field.class}
                                    placeholder={field.placeholder}
                                    values={field.values}
                                    handlechange={handlechange}
                                    componentprops={props}
                                />
                            );
                        }
                        if ("textarea" === field.element) {
                            return (
                                <TextAreaField
                                    key={index}
                                    name={field.name}
                                    label={field.label}
                                    grpmd={field.grpmd}
                                    ref={field.ref}
                                    rows={field.rows}
                                    fieldClass={field.class}
                                    labelClass={field.labelClass}
                                    placeholder={field.placeholder}
                                    required={field.required}
                                    handlechange={handlechange}
                                />
                            );
                        }
                        if ("checkbox" === field.element) {
                            return (
                                <CheckboxField
                                    key={index}
                                    name={field.name}
                                    ref={field.ref}
                                    value={field.value}
                                    fieldClass={field.class}
                                    placeholder={field.placeholder}
                                    required={field.required}
                                    handlechange={handlechange}
                                />
                            );
                        }
                        if ("html" === field.element) {
                            return (
                                <HtmlBox
                                    key={index}
                                    text={field.text}
                                    fieldClass={field.class}
                                />
                            );
                        }
                        if ("captcha" === field.element && showCapcha) {
                            return (
                                <ReCaptchaBox
                                    key={index}
                                    fieldClass={field.class}
                                    captRef={field.captchaRef}
                                    handleonVerify={handleonVerify}
                                />
                            );
                        }
                        if ("button" === field.element) {
                            return (    
                                <ButtonField
                                    key={index}
                                    name={field.name}
                                    fieldClass={field.class}
                                    type={field.type}
                                    value={field.value}
                                    grpmd={field.grpmd}
                                />
                            );
                        }
                    })
                    }
                </Row>
            </Form>
        </div>
    );
}


const ContactFormPage = (props) => (
    <MySimpleForm {...props}/>
)

export default ContactFormPage
